var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 52,
    viewBox: "0 0 100 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9420_104370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6039 26.0017C35.6039 27.5791 35.1137 29.1211 34.1953 30.4327C33.2769 31.7443 31.9715 32.7665 30.4443 33.3702C28.917 33.9739 27.2365 34.1318 25.6152 33.8241C23.9938 33.5163 22.5045 32.7567 21.3356 31.6413C20.1667 30.5259 19.3707 29.1048 19.0482 27.5576C18.7257 26.0105 18.8912 24.4069 19.5238 22.9495C20.1564 21.4922 21.2277 20.2465 22.6022 19.3702C23.9767 18.4938 25.5927 18.026 27.2458 18.026C29.4625 18.026 31.5884 18.8663 33.1559 20.362C34.7233 21.8578 35.6039 23.8864 35.6039 26.0017ZM30.8033 50.7605C29.9396 50.7604 29.0899 50.5522 28.333 50.155C27.5762 49.7578 26.9368 49.1846 26.4742 48.4885C26.0116 47.7925 25.7407 46.9962 25.6868 46.1736C25.6329 45.351 25.7977 44.5288 26.1658 43.7832L28.1232 39.841C27.842 39.8571 27.5439 39.8678 27.2542 39.8678C24.7659 39.8706 22.3185 39.2637 20.1464 38.1053C17.9743 36.9469 16.1502 35.2758 14.8489 33.2519C13.5476 31.228 12.8126 28.9193 12.7143 26.5467C12.6161 24.1741 13.1578 21.8172 14.2877 19.7016C15.4175 17.5861 17.0977 15.7828 19.1672 14.4644C21.2367 13.146 23.6263 12.3567 26.1071 12.1721C28.5879 11.9876 31.0768 12.4138 33.3355 13.4102C35.5942 14.4065 37.547 15.9395 39.0068 17.8623L44.8058 6.11892C41.1804 3.20764 36.822 1.2491 32.1608 0.436702C27.4996 -0.375695 22.697 -0.013843 18.2272 1.48652C13.7574 2.98689 9.77503 5.57387 6.67339 8.99199C3.57176 12.4101 1.45813 16.5411 0.541236 20.9771C-0.375654 25.413 -0.0640877 30.0005 1.44517 34.2864C2.95442 38.5724 5.60915 42.4085 9.1472 45.416C12.6852 48.4235 16.9842 50.4983 21.6196 51.4356C26.2549 52.3729 31.0663 52.1402 35.5786 50.7605H30.8033Z",
    fill: "url(#paint0_linear_9420_104370)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3541 39.7384C49.4911 39.7367 48.6425 39.5273 47.8869 39.1296C47.1312 38.7318 46.4929 38.1586 46.0311 37.4629C45.5693 36.7673 45.2989 35.9717 45.2449 35.1498C45.1909 34.3279 45.3551 33.5063 45.7223 32.7611L58.268 7.40647C58.5555 6.82499 58.9602 6.30324 59.459 5.87101C59.9578 5.43878 60.541 5.10453 61.1752 4.88736C61.8094 4.67019 62.4822 4.57434 63.1552 4.60528C63.8282 4.63623 64.4883 4.79337 65.0976 5.06772C65.707 5.34208 66.2538 5.72828 66.7068 6.20427C67.1597 6.68027 67.51 7.23674 67.7376 7.8419C67.9652 8.44707 68.0656 9.08909 68.0332 9.73131C68.0008 10.3735 67.8361 11.0033 67.5486 11.5848L55.0029 36.9341C54.5875 37.7748 53.9295 38.4851 53.1062 38.9818C52.2828 39.4785 51.3282 39.741 50.3541 39.7384Z",
    fill: "#001689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8854 39.7384C64.0224 39.7367 63.1738 39.5273 62.4181 39.1296C61.6625 38.7318 61.0242 38.1586 60.5624 37.4629C60.1006 36.7673 59.8302 35.9717 59.7762 35.1498C59.7222 34.3279 59.8863 33.5063 60.2535 32.7611L72.7992 7.40647C73.2626 6.47069 74.025 5.69925 74.9769 5.20309C75.9287 4.70693 77.021 4.51162 78.0965 4.64524C79.1721 4.77886 80.1755 5.23453 80.9625 5.94672C81.7495 6.65891 82.2795 7.59093 82.4763 8.60872L84.4872 19.0264L90.2383 7.40647C90.5258 6.82499 90.9305 6.30324 91.4294 5.87101C91.9282 5.43878 92.5114 5.10453 93.1456 4.88736C93.7797 4.67019 94.4526 4.57434 95.1256 4.60528C95.7986 4.63623 96.4586 4.79337 97.068 5.06772C97.6774 5.34208 98.2242 5.72828 98.6771 6.20427C99.1301 6.68027 99.4804 7.23673 99.7079 7.8419C99.9355 8.44707 100.036 9.08909 100.004 9.7313C99.9711 10.3735 99.8064 11.0033 99.5189 11.5848L86.9732 36.9341C86.5099 37.8698 85.7474 38.6413 84.7956 39.1374C83.8437 39.6336 82.7514 39.8289 81.6759 39.6953C80.6003 39.5617 79.5969 39.106 78.8099 38.3938C78.0229 37.6816 77.4929 36.7496 77.2961 35.7318L75.2853 25.3141L69.5369 36.9341C69.1205 37.7746 68.4619 38.4847 67.6382 38.9813C66.8145 39.4779 65.8597 39.7405 64.8854 39.7384Z",
    fill: "#001689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8717 50.7598H30.8033C29.9395 50.7598 29.0898 50.5515 28.333 50.1543C27.5761 49.7571 26.9367 49.1839 26.4741 48.4879C26.0115 47.7919 25.7407 46.9956 25.6868 46.173C25.6328 45.3504 25.7976 44.5281 26.1658 43.7825L45.8857 3.93382C46.4663 2.75946 47.5121 1.85331 48.7929 1.41471C50.0737 0.976105 51.4847 1.04098 52.7153 1.59507C53.946 2.14915 54.8956 3.14705 55.3553 4.36925C55.8149 5.59144 55.7469 6.93781 55.1663 8.11217L38.8914 40.9755H76.8576C78.2173 40.9755 79.5213 41.4909 80.4828 42.4084C81.4443 43.3258 81.9844 44.5702 81.9844 45.8677C81.9844 47.1651 81.4443 48.4095 80.4828 49.327C79.5213 50.2444 78.2173 50.7598 76.8576 50.7598H76.8717Z",
    fill: "url(#paint1_linear_9420_104370)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9420_104370",
    x1: 12.9171,
    y1: 3.86738,
    x2: 38.0129,
    y2: 49.4202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#F7EF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E3E81A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C1DC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#92CC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#88C86F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#29B6C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#02A8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0799DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0F7FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1B5AAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A2A86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9420_104370",
    x1: 32.3641,
    y1: 10.3798,
    x2: 60.1161,
    y2: 60.7501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#F7EF07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E3E81A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C1DC3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#92CC66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#88C86F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#29B6C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#02A8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0799DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0F7FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1B5AAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A2A86"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9420_104370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 52,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0f651a0cf9f1d78e79fdbb7099208efe.svg";
export { ForwardRef as ReactComponent };